<template>
	<span class="row toggle-switch" :class="{'separated' : checkedText || uncheckedText}">
		<small class="text rigid" :class="{checked:value}">{{ value ? checkedText : uncheckedText }}</small>
		<label :for="id" class="switch rigid">
		  	<input :checked="value" @change="onChange" :disabled="disabled" type="checkbox">
		  	<span class="slider round"></span>
		</label>
	</span>
</template>

<script>
export default {
	name: 'ToggleSwitch',
	props: {
		value: Boolean,
		id: String,
		disabled: Boolean,
		checkedText: String,
		uncheckedText: String
	},
	methods: {
		onChange(event){
			this.$emit('change', event.target.checked);
		}
	}
};
</script>

<style>
	.toggle-switch {
		/* padding: 9px 0; */
	}
	.text {
		color: #999;
	}
	.text.checked {
		color: #337CCA;
	}
	/* The switch - the box around the slider */
	.switch {
		font-size: 18px;
		position: relative;
		display: inline-block;
		width: 2em;
		height: 1em;
		box-sizing: border-box;
	}

	/* Hide default HTML checkbox */
	.switch input {
		display:none;
	}

	/* The slider */
	.slider {
		position: absolute;
		cursor: pointer;
		padding: .08em;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: #ccc;
		transition: .4s;

	}
	.dark .slider {
		background-color: #333;
	}

	.slider:before {
		position: absolute;
		content: "";
		top: 0;
	    right: 0;
	    bottom: 0;
	    left: 0;
		height: 1em;
		width: 1em;
		background-color: white;
		transition: .4s;
		border: 1px solid #aaa;
		box-sizing: border-box;
	}
	.dark .slider:before {
		background-color: #272727;
		border-color: #555;
	}

	input:checked + .slider {
		background-color: #337CCA;
	}

	input:checked + .slider:before {
		border-color: #337CCA;
	}

	input:focus + .slider {
		box-shadow: 0 0 1px #337CCA;
	}

	input:checked + .slider:before {
		transform: translateX(1em);
	}

	/* Rounded sliders */
	.slider.round {
		border-radius: 1.25em;
	}

	.slider.round:before {
		border-radius: 50%;
	}
</style>



// WEBPACK FOOTER //
// ./src/components/ToggleSwitch.vue